import { Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import {
  Button,
  Loader,
  Modal,
  ModalActions,
  ModalContent,
  ModalDescription,
  ModalHeader,
  Segment,
} from 'semantic-ui-react';

import COLORS from '../../../constants/colors';
import { useGetEvalPrepTask } from 'actions/eval-prep-visibility';
import { formatEpochIst } from '../constants';

const Line = ({ label, value }) => (
  <>
    <Text variant="body3" color={COLORS.GRAY}>
      {label}
    </Text>
    <Text variant="body1Regular">{value ?? '—'}</Text>
    <Separator height={10} transparent />
  </>
);

const StepCard = ({ title, step, task }) => (
  <Segment>
    <Text variant="body1Medium">{title}</Text>
    <Separator height={10} transparent />
    <Line label="Raised at" value={formatEpochIst(step?.raised_at)} />
    <Line label="Deadline" value={formatEpochIst(step?.deadline_at)} />
    <Line label="Status" value={step?.status?.toLowerCase()} />
    <Line label="Task state" value={task?.state} />
    <Line label="Clicked" value={task?.clicked_on ? 'yes' : 'no'} />
    <Line label="Points" value={task?.points} />
    <Line label="Task id" value={step?.task_id} />
  </Segment>
);

const PrepTaskDetail = ({ intelEnrollmentId, closeModal }) => {
  const {
    data,
    get: getPrepTask,
    isProcessing,
    error: loadError,
  } = useGetEvalPrepTask();

  React.useEffect(() => {
    getPrepTask(intelEnrollmentId);
  }, [getPrepTask, intelEnrollmentId]);

  const tasks = data?.tasks || {};

  return (
    <Modal open onClose={closeModal}>
      <ModalHeader>
        <Text variant="h6">Prep detail</Text>
        <Text variant="body3" color={COLORS.GRAY}>
          {data?.student_name ? `${data.student_name} · ` : ''}
          {intelEnrollmentId}
        </Text>
      </ModalHeader>
      <ModalContent scrolling>
        <ModalDescription>
          {isProcessing ? (
            <Loader active inline="centered">
              Loading...
            </Loader>
          ) : loadError ? (
            <Text variant="body2" color={COLORS.RUSTY_RED}>
              {loadError.message || 'Could not load this student&apos;s prep.'}
            </Text>
          ) : (
            <>
              <Line label="Coach" value={data?.teacher_name} />
              <Line label="Mapping state" value={data?.state} />
              <Line label="First class" value={formatEpochIst(data?.first_class_at)} />
              <Line label="Eval demo" value={data?.student_demo_id} />
              {data?.never_pushed && (
                <Text variant="body2" color={COLORS.RUSTY_RED}>
                  The training tool never registered this student, so no card was
                  raised. Use Trigger Student Handoff once that is fixed.
                </Text>
              )}
              <Separator height={14} transparent />
              <StepCard
                title="Handoff"
                step={data?.handoff}
                task={tasks.STUDENT_HANDOFF}
              />
              <StepCard
                title="Readiness"
                step={data?.readiness}
                task={tasks.STUDENT_READINESS}
              />
            </>
          )}
        </ModalDescription>
      </ModalContent>
      <ModalActions>
        <Button color="black" onClick={closeModal}>
          Done
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default PrepTaskDetail;
